"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  newDate: null
};
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "DateToAdd*");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null);
class AddCalendarDate extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_validateDate", value => {
      const calendarDates = this.props.calendar.calendarDates.map(d => d.id);
      if (calendarDates.includes(value)) return 'Date already in the calendar';
    });
    _defineProperty(this, "_onAddDate", () => {
      this.props.addCalendarDate(this.props.calendar.id, this.state.newDate);
      this.setState(initialState);
      this.props.onCloseCancel();
    });
    _defineProperty(this, "_setValue", (value, field) => {
      this.setState({
        [field]: value
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Add a Date to the Calendar",
      onClose: this.props.onCloseCancel,
      buttons: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.props.onCloseCancel
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "primary",
        onClick: this._onAddDate,
        disabled: !this.state.newDate
      }, "Add To Calendar"))
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Date",
      name: "newDate",
      value: this.state.newDate,
      onChange: this._setValue,
      required: true,
      customValidation: value => this._validateDate(value)
    }))), !this.state.newDate ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, (0, _occasion.default)(this.state.newDate, 'dddd D MMMM YYYY')))), !this.state.newDate || (0, _occasion.default)(this.state.newDate, 'YYYY') === this.props.calendar.id + '' ? null : /*#__PURE__*/_react.default.createElement("p", {
      className: "text-danger"
    }, "Are you sure you mean to add a ", (0, _occasion.default)(this.state.newDate, 'YYYY'), " date to the ", this.props.calendar.id, ' ', "calendar?"));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(AddCalendarDate, "partialQueries", {
  Calendar: {
    id: true,
    calendarDates: {
      id: true
    }
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(AddCalendarDate, undefined, (client, props) => ({
  addCalendarDate(calendarID, newDate) {
    return client.update('CalendarDate.create', {
      calendarID,
      newDate
    });
  }
}));